import { Typography } from '@telavita-core/react-design-kit'
import styled from 'styled-components'

interface LoadingProps {
  isLoading: boolean
}

interface EmptyProps {
  isEmpty: boolean
}

interface GraphicWrapperProps extends LoadingProps, EmptyProps {}

export const GraphicWrapper = styled.div<GraphicWrapperProps>`
  display: flex;
  align-items: flex-end;
  opacity: ${({ isLoading, isEmpty }) => (isLoading || isEmpty) && 0};
`

export const LeftSection = styled.div`
  width: 100px;
  display: flex;
  flex-direction: column;
  gap: 3px;
  border-right: 1px solid #e2e2e2;

  > div {
    margin-top: 10px;
    padding-right: 7px;
  }
`

export const LeftSectionText = styled(Typography)`
  font-size: 12px;
  line-height: 15px;
`

export const BadgeText = styled(Typography)`
  color: #898989;
  font-size: 12px;
  line-height: 13px;
`

export const Loading = styled.div`
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
`